import {Keyboard, type KeyboardInfo} from '@capacitor/keyboard'

const SCROLL_MARGIN = 16 // px extra space above keyboard

function getScrollRoot(): HTMLElement {
  return document.documentElement
}

function scrollFocusedIntoView(info: KeyboardInfo) {
  const el = document.activeElement as HTMLElement | null
  if (!el || !('getBoundingClientRect' in el)) return

  const rect = el.getBoundingClientRect()
  const viewportHeight = window.innerHeight - info.keyboardHeight

  const visibleBottom = viewportHeight - SCROLL_MARGIN

  // If the input’s bottom is below the visible bottom, scroll it up by the delta.
  const delta = rect.bottom - visibleBottom
  if (delta > 0) {
    const scrollEl = getScrollRoot()
    scrollEl.scrollBy({top: delta, behavior: 'smooth'})
  }
}

export function installKeyboardScroll() {
  Keyboard.addListener('keyboardDidShow', scrollFocusedIntoView).then()
}
